import { render, staticRenderFns } from "./SectionGalleryV1.vue?vue&type=template&id=1cc0eda5&scoped=true&"
import script from "./SectionGalleryV1.vue?vue&type=script&lang=js&"
export * from "./SectionGalleryV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionGalleryV1.vue?vue&type=style&index=0&id=1cc0eda5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0eda5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsCommonOrganismImageSlider: require('/app/components/organisms/common/OrganismImageSlider.vue').default})
